import { createStyles } from 'antd-style';

const useProposalResultStyles = createStyles(({ token, css }) => ({
  container: css`
    width: 100%;
    border-radius: 16px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-height: 500px;
  `,

  // 顶部数据展示区域 - 改为同一行布局
  topSection: css`
    display: flex;
    gap: 24px;
    align-items: flex-start;

    @media (max-width: 992px) {
      flex-direction: column;
    }
  `,

  // 左侧点赞数据列 - 垂直布局
  statsColumn: css`
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-width: 180px;
  `,

  // 点赞数据项 - 优化样式
  statItem: css`
    display: flex;
    flex-direction: column;
    padding: 20px;
    background: #fff;
    border-radius: 12px;

    text-align: center;
    gap: 8px;
  `,

  statLabel: css`
    font-size: 14px;
    color: ${token.colorTextSecondary};
    font-weight: 500;
  `,

  statNumber: css`
    font-size: 28px;
    font-weight: 700;
    color: ${token.colorText};
    line-height: 1;
  `,

  statTrend: css`
    font-size: 12px;
    font-weight: 500;
    color: ${token.colorSuccess};
  `,

  // 右侧图表区域 - 只保留雷达图
  chartContainer: css`
    flex: 1;
    background: #fff;

    border-radius: 12px;
    padding: 20px;
    min-height: 300px;
  `,

  chartTitle: css`
    font-size: 16px;
    font-weight: 500;
    color: ${token.colorText};
    margin-bottom: 16px;
    text-align: center;
  `,

  // 社区反馈区域
  feedbackSection: css`
    padding-top: 24px;
    border-radius: 12px;
    border: 1px solid black;
    padding: 20px;
  `,

  feedbackHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  `,

  feedbackTitle: css`
    font-size: 18px;
    font-weight: 500;
    color: ${token.colorText};
    margin: 0;
  `,

  feedbackCount: css`
    font-size: 14px;
    color: ${token.colorTextSecondary};
  `,

  // 社区反馈列表外层，固定高度可滚动
  feedbackListWrapper: css`
    max-height: 320px;
    min-height: 120px;
    overflow-y: auto;
    margin-bottom: 16px;
    padding-right: 4px;
  `,

  // 社区反馈输入区域
  feedbackInput: css`
    border-top: 1px solid ${token.colorBorderSecondary};
    padding-top: 20px;
  `,

  inputContainer: css`
    display: flex;
    gap: 12px;
    align-items: flex-end;
  `,

  textAreaWrapper: css`
    flex: 1;
  `,

  feedbackTextArea: css`
    border-radius: 12px;
    resize: none;

    &:hover {
      border-color: ${token.colorPrimary};
    }

    &:focus {
      border-color: ${token.colorPrimary};
      box-shadow: 0 0 0 2px ${token.colorPrimaryBg};
    }
  `,

  submitButton: css`
    border-radius: 12px;
    min-width: 80px;
    height: 40px;
    background-color: ${token.colorPrimary};
    border-color: ${token.colorPrimary};

    &:hover {
      background-color: ${token.colorPrimaryHover};
      border-color: ${token.colorPrimaryHover};
    }

    &:disabled {
      background-color: ${token.colorBgContainerDisabled};
      border-color: ${token.colorBorderSecondary};
      color: ${token.colorTextDisabled};
    }
  `,

  // 社区反馈列表
  feedbackList: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,

  feedbackItem: css`
    display: flex;
    gap: 12px;
    padding: 16px;
    background: #fff;
    border-radius: 12px;
    border: 1px solid ${token.colorBorderSecondary};
    transition: all 0.2s;

    &:hover {
      border-color: ${token.colorPrimary};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  `,

  feedbackAvatar: css`
    flex-shrink: 0;
  `,

  feedbackContent: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,

  feedbackItemHeader: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,

  feedbackAuthor: css`
    font-size: 14px;
    font-weight: 500;
    color: ${token.colorText};
  `,

  feedbackTime: css`
    font-size: 12px;
    color: ${token.colorTextTertiary};
  `,

  feedbackText: css`
    font-size: 14px;
    color: ${token.colorText};
    line-height: 1.5;
  `,

  // 空状态
  emptyFeedback: css`
    text-align: center;
    padding: 40px 20px;
    color: ${token.colorTextTertiary};
    font-size: 14px;
  `,

  emptyIcon: css`
    font-size: 48px;
    color: ${token.colorTextQuaternary};
    margin-bottom: 12px;
  `,

  // 加载状态
  loadingContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
  `,

  // 删除不需要的样式
  // statsRow, chartsSection, commentsSection, commentsList, commentInput 等已删除

  // 图表横向排列
  chartRow: css`
    display: flex;
    gap: 24px;
    flex: 1;
    @media (max-width: 992px) {
      flex-direction: column;
      gap: 16px;
    }
  `,

  statsRow: css`
    display: flex;
    gap: 24px;
    padding: 20px;
    align-items: flex-start;
    border-radius: 20px;
    background: #fff;
    width: 100%;
  `,
}));

export default useProposalResultStyles;
